<template>
  <div class="ZxPopbox clearfix" :class="{ show: visible }">
    <a href="javascript:void(0);" class="close" @click="hide"><i class="iconfont icongb"></i></a>

    <div class="img">
      <div class="ewm"><a class="ico"><img src="static/picture/20210702150838515.png"></a>
        <img src="static/picture/zixun.jpg" class="ewmimg">
      </div>
      <p>{{ $t('pages.news.wechatService') }}</p>
    </div>

    <div class="info">
      <p><span>{{ $t('pages.news.phone') }}</span>15522149960</p>
      <p><span>{{ $t('pages.news.email') }}</span>info@biocoupling.com</p>
      <p><span>{{ $t('pages.news.address') }}</span>{{ $t('footer.addressText') }}{{ $t('footer.addressDetail') }}</p>
    </div>
  </div>
</template>

<script>
import { useConsultPopup } from '@/composables/useConsultPopup';

export default {
  name: 'ZxPopbox',
  setup() {
    const { visible, hide } = useConsultPopup();
    return { visible, hide };
  }
};
</script>

<style scoped>
.ZxPopbox {
  display: none;
}
.ZxPopbox.show {
  display: block;
}
</style>
